import React from 'react';

import './how-to.styles.scss';

export const HowTo = content => (
    <div className="how-to">
        <div className="container">
            <h3>How to Build This in CrowdRiff</h3>
            <div dangerouslySetInnerHTML={{ __html: content.content}} className="content-wrapper" />
        </div>
    </div>
)